import React, { useState, useRef } from "react";
import classes from "./Tabs.module.css";
import Policies from "./Policies/Policies";
import RefundPolicy from "./RefundPolicy/RefundPolicy";
import { Itinerary } from "./Itinerary/Itinerary";
import { QuickDetails } from "./QuickDetails/QuickDetails";

export const Tabs = ({ itineraryViewModel, quickDetailsViewModel }) => {
  let [tab, setTab] = useState(1);

  const itRef = useRef(null);
  const quickRef = useRef(null);
  const policyRef = useRef(null);
  const refundRef = useRef(null);

  const tabClickHandler = (e) => {
    if (window.innerWidth < 769) {
      if (e === 1) {
        itRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (e === 2) {
        itRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      } else if (e === 3) {
        quickRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      } else {
        policyRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }
    }
    setTab(e);
  };

  return (
    <>
      <div className={classes["trip-desc-container"]}>
        <div className={classes["tabs-container"]}>
          <button
            style={{
              backgroundColor: `${tab === 1 ? "#e65439" : ""}`,
              color: `${tab === 1 ? "white" : ""}`,
            }}
            className={classes["tabs-button"]}
            onClick={() => {
              return tabClickHandler(1);
            }}
            ref={itRef}
          >
            Itinerary
          </button>
          <div className={classes["mobile-tabs"]}>
            <div style={{ display: `${tab === 1 ? "" : "none"}` }}>
              <Itinerary itineraryViewModel={itineraryViewModel} />
            </div>
          </div>
          <button
            style={{
              backgroundColor: `${tab === 2 ? "#e65439" : ""}`,
              color: `${tab === 2 ? "white" : ""}`,
            }}
            className={classes["tabs-button"]}
            onClick={() => {
              return tabClickHandler(2);
            }}
            ref={quickRef}
          >
            Quick Details
          </button>
          <div className={classes["mobile-tabs"]}>
            <div style={{ display: `${tab === 2 ? "" : "none"}` }}>
              <QuickDetails quickDetailsViewModel={quickDetailsViewModel} />
            </div>
          </div>
          <button
            style={{
              backgroundColor: `${tab === 3 ? "#e65439" : ""}`,
              color: `${tab === 3 ? "white" : ""}`,
            }}
            className={classes["tabs-button"]}
            onClick={() => {
              return tabClickHandler(3);
            }}
            ref={policyRef}
          >
            Policies
          </button>
          <div className={classes["mobile-tabs"]}>
            <div style={{ display: `${tab === 3 ? "" : "none"}` }}>
              <Policies />
            </div>
          </div>
          <button
            style={{
              backgroundColor: `${tab === 4 ? "#e65439" : ""}`,
              color: `${tab === 4 ? "white" : ""}`,
            }}
            className={classes["tabs-button"]}
            onClick={() => {
              return tabClickHandler(4);
            }}
            ref={refundRef}
          >
            Refund Policy
          </button>
          <div className={classes["mobile-tabs"]}>
            <div style={{ display: `${tab === 4 ? "" : "none"}` }}>
              <RefundPolicy />
            </div>
          </div>
        </div>
        <div className={classes["tabs-data-container"]}>
          {tab === 1 ? (
            <Itinerary itineraryViewModel={itineraryViewModel} />
          ) : tab === 2 ? (
            <QuickDetails quickDetailsViewModel={quickDetailsViewModel} />
          ) : tab === 3 ? (
            <Policies />
          ) : (
            <RefundPolicy />
          )}
        </div>
      </div>
    </>
  );
};
